import $ from 'jquery';

function insertSwiperThumbs($el, type) {
  const $thumbs = $el.clone();
  $thumbs.removeClass(`swiper--${type}`).addClass(`swiper--${type}-thumbs mt-5`);
  $thumbs
    .find('.swiper-slide')
    .removeAttr('data-fancybox')
    .removeAttr('data-src')
    .removeAttr('data-id');
  $el.after($thumbs);

  return new Swiper($thumbs[0], {
    spaceBetween: 12,
    slidesPerView: 5,
    createElements: true,
    watchSlidesProgress: true,
  });
}

function changeKeyVisionBackgroundImage(swiper) {
  let { slides, activeIndex } = swiper;
  let src = slides[activeIndex].querySelector('img')?.src;
  if (src) {
    $(swiper.el)
      .closest('.top-key-vision')
      .css({
        'background-image': `url(${src})`,
      });
  }
}

$.fn.swiper = function (opts = {}) {
  this.each(function () {
    let $this = $(this);
    let swiperDom = $this.data('swiper');
    if (swiperDom) {
      swiperDom.update();
      return swiperDom;
    }

    let thumbsSwiper;
    if (opts === 'swiper-video-with-thumbs') thumbsSwiper = insertSwiperThumbs($this, 'video');
    if (opts === 'swiper-image-with-thumbs') thumbsSwiper = insertSwiperThumbs($this, 'image');
    const parameterSet = {
      ['top-key-vision']: {
        autoplay: {
          delay: 5000,
        },
        on: {
          init(swiper) {
            changeKeyVisionBackgroundImage(swiper);
          },
          slideChange(swiper) {
            changeKeyVisionBackgroundImage(swiper);
          },
        },
      },
      ['home-product-list']: {
        navigation: true,
        slidesPerView: 3,
        grid: {
          rows: 2,
        },
        spaceBetween: 24,
        _insertWrap: true,
        on: {
          init(swiper) {
            const $swiper = $(swiper.$el[0]);
            const $block = $swiper.closest('.block');
            const $blockFooter = $block.find('.block__footer').addClass('swiper-controller');
            if (swiper.pagination.$el) {
              const $pagination = $(swiper.pagination.$el[0]);
              $pagination.appendTo($blockFooter);
              $pagination.before($(swiper.navigation.$prevEl));
              $pagination.after($(swiper.navigation.$nextEl));
            }
          },
        },
      },
      ['home-community-activism']: {},
      ['swiper-video-with-thumbs']: {
        pagination: false,
        navigation: true,
        spaceBetween: 20,
        thumbs: {
          swiper: thumbsSwiper,
        },
      },
      ['swiper-image-with-thumbs']: {
        pagination: false,
        navigation: true,
        spaceBetween: 20,
        thumbs: {
          swiper: thumbsSwiper,
        },
      },
      ['supplier-detail-home']: {
        spaceBetween: 24,
        noSwiping: true,
        noSwipingClass: 'plyr__controls',
        on: {
          init(swiper) {
            const $swiper = $(swiper.$el[0]);
            if (swiper.pagination.$el) {
              const $controller = $('<div class="swiper-controller mt-3"></div>');
              $controller.append(swiper.pagination.$el);
              $swiper.closest('.ratio').after($controller);
            }
          },
        },
      },
    };
    let _opts;
    if (typeof opts === 'string') _opts = parameterSet[opts] || {};
    else _opts = opts;

    const defaultSwiperParams = {
      pagination: {
        auto: true,
        clickable: true,
      },
      createElements: true,
      on: {
        init(swiper) {
          if (_opts?._insertWrap === true) {
            setTimeout(() => {
              $(swiper.el).wrap('<div class="swiper-overflow-wrap"></div>');
            });
          }
          if (_opts?.grid?.rows) swiper.el.style.setProperty('--rows', _opts?.grid?.rows);
          _opts?.on?.init && _opts.on.init.call(swiper, swiper);
        },
        slideChangeTransitionEnd() {
          this.slides.find('video').each(function () {
            this.pause();
          });
        },
      },
    };

    let mergerOpt = {};

    $.extend(true, mergerOpt, _opts, defaultSwiperParams);

    if (_opts.pagination !== undefined) {
      mergerOpt.pagination = _opts.pagination;
    }

    $this.data('swiper', new Swiper(this, mergerOpt));
  });
};
